export const mylotusConstants = {
  EDIT_EARN_REPORT_SUCCESS: "EDIT_EARN_REPORT_SUCCESS",
  TABLE_EARN_REPORT_RELOAD_SUCCESS: "TABLE_EARN_REPORT_RELOAD_SUCCESS",

  ADD_QUOTA_SUCCESS: "ADD_QUOTA_SUCCESS"
};
